import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/charts`;

export const ROUTE: RouteDefinition = `${baseRoute}/charts`;

export const URL = (): RouteDefinition => `${baseRoute}/charts`;
